import styled from 'styled-components';

export const Container = styled.div`
  display: flex;
  width: ${(props) => props.width};
  background: ${(props) =>
    props.title === 'light' || props.login
      ? props.theme.colors.lightgrey
      : props.theme.colors.darker};
  color: ${(props) => props.theme.colors.label};
  font-size: 12px;
  border-radius: 10px;
  align-items: center;
  justify-content: flex-start;
  text-align: center;
  margin: 15px 15px 15px 0;
  padding: ${(props) => !props.noPadding && '8px 20px 8px 5px'};
  /* Hairline e foco nos tokens CCO — alinha o input legado ao resto do
     design (backgrounds ficam no tema por compat com o light theme). */
  border: 1px solid var(--cco-line);
  ${(props) => props.focused && `border-color: var(--cco-blue)`};
  ${(props) => props.height && `height: ${props.height}`};
  ${(props) => props.disabled && `cursor: not-allowed`};
`;

export const Input = styled.input`
  width: 100%;
  min-width: 40px;
  height: ${(props) => props.height || '60px'};
  font-size: 12px;
  margin: 0 15px 0 0;
  color: ${({ theme }) => theme.colors.darker};
  border-radius: 10px;
  :disabled {
    cursor: not-allowed;
    opacity: 0.8;
  }
  background: ${(props) =>
    props.title === 'light' || props.login
      ? props.theme.colors.lightgrey
      : props.theme.colors.darker};

  &::placeholder {
    color: ${({ theme }) => theme.colors.label};
  }

  /* Mobile: 60px de altura fica desproporcional na tela pequena — reduz
     pra 44px (padrao de toque) quando o consumidor nao fixou height. */
  @media (max-width: 720px) {
    height: ${(props) => props.height || '44px'};
  }
`;

export const Icon = styled.img`
  width: ${(props) => (props.size ? props.size : '30px')};
  height: ${(props) => (props.size ? props.size : '30px')};
  margin: 15px;
  cursor: pointer;
`;

// Wrapper pro novo prop `icon` (React node — usa <Icon name="search" />).
// Footprint visual similar ao <s.Icon img> legado, mas o SVG inline herda
// cor do tema via currentColor (color do label combina com placeholder).
export const IconWrapper = styled.span`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  margin: 0 12px;
  color: ${(props) => props.theme.colors.label};
  flex-shrink: 0;
`;
